export default "__VITE_ASSET__DOH_wQFK__"